import { defineComponent as _defineComponent } from 'vue'
import moment from 'moment';
import { computed } from 'vue';


export default /*#__PURE__*/_defineComponent({
  __name: 'ApplicationFooter',
  setup(__props) {

const copyright = computed(() => `Copyright © AUMOVIO Digital Services France ${moment().format('YYYY')}`);


return { __sfc: true,copyright }
}

})